import { Injectable, inject } from '@angular/core';
import { NativeDateAdapter } from '@angular/material/core';

import { UserDatePipe } from '../../shared/pipes/date/local-date.pipe';
import { DateTimeService } from '../services/date-time/date-time.service';

@Injectable()
export class CustomFnsDateAdapter extends NativeDateAdapter {
  protected dateTimeService: DateTimeService;
  protected localDatePipe = inject(UserDatePipe);

  constructor() {
    const dateTimeService = inject(DateTimeService);

    super();
    this.setLocale(dateTimeService.getLanguage());

    this.dateTimeService = dateTimeService;
  }

  override format(date: Date, _displayFormat: string): string {
    return this.localDatePipe.transform(date, 'notime');
  }

  override getFirstDayOfWeek(): number {
    return 1;
  }
}
